export const periodDisplayFormat = 'MMMM YYYY';
